<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:90%;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">子设备列表({{childDeviceNumber}}个)</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0;">
        <div v-if="loading" style="margin-top:10rem;"><LoadingText /></div>
        <div v-else>
          <div style="padding:0.9rem 1.1rem 2rem;">
            <!-- <div>
              <div style="padding-bottom:0.3rem;color:#9e9e9e;">子设备列表({{childDeviceNumber}}个)</div>
            </div> -->
            <div style="margin-top:0.2rem;">
              <div v-if="loading" style="padding-top:6.5rem;">
                <LoadingText />
              </div>
              <div v-else v-for="(item,index) in childDevice" :key="index" style="border-bottom:1px solid #eee;" >
                <DeviceCard :dev-info="item" :idx=" index + 1 " :off-line="offLine" flat />
              </div>
              <ListFooter v-if="!loading" :count="childDevice.length" />
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import DeviceCard from './DeviceCard'
import ListFooter from '../../components/ListFooterV2'
export default {
  components: {
    LoadingText,
    DeviceCard,
    ListFooter
  },
  props: {},
  data() {
    return {
      iotId: '',
      loading: true,
      childDevice: {},
      childDeviceNumber: 0,
      offLine: false
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.iotId = that.$route.query.iot_id
    if (that.$route.query.offLine) {
      that.offLine = (that.$route.query.offLine === 'true' || that.$route.query.offLine === true)
    }
    await that.getGatewayChildDevice()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    // 获取网关子设备信息
    async getGatewayChildDevice() {
      var that = this
      var res = await that.$api.iot.getGatewayChild({ iot_id: that.iotId })
      // console.log('getDevice.res', res);
      if (!res.success) {
        console.log('获取网关子设备信息失败', res);
        that.childDeviceNumber = 0
        return
      }
      var data = res.data
      that.childDevice = data
      that.childDeviceNumber = data.length
      // console.log(data)
    }
  }
}
</script>

<style scoped>
.us-v-app /deep/ .v-app-bar--fixed{
  z-index: 10000000 !important;
}
</style>
